import { render, staticRenderFns } from "./OnboardingSlide.vue?vue&type=template&id=721653ea&scoped=true"
import script from "./OnboardingSlide.vue?vue&type=script&lang=ts"
export * from "./OnboardingSlide.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingSlide.vue?vue&type=style&index=0&id=721653ea&prod&scoped=true&lang=scss"
import style1 from "./OnboardingSlide.vue?vue&type=style&index=1&id=721653ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721653ea",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QImg,QCardSection,QScrollArea,QBtn});
